<template>
  <div class="home">
    <img style="width: 100%" src="../assets/index.gif" />
    <div class="input" style="margin-top: 10px">
      <nut-input
        label-width="50"
        :border="false"
        label="学校"
        readonly
        v-model="school.name"
      />
      <nut-input
        label-width="50"
        :border="false"
        label="班级"
        readonly
        placeholder="点击选择班级"
        v-model="classObject.text"
        @click="clickSelectClass"
      />
      <nut-input
        label-width="50"
        :border="false"
        label="套餐"
        readonly
        placeholder="点击选择套餐"
        v-model="productObject.text"
        @click="clickSelectProduct"
      />
      <nut-input
        label-width="70"
        :border="false"
        label="姓名"
        placeholder="请输入真实姓名"
        v-model="realName"
        max-length="20"
      />
      <nut-input
        label-width="70"
        :border="false"
        label="出生日期"
        placeholder="点击选择出生日期"
        readonly
        v-model="dateTimeStr"
        @click="clickSelectDate"
        max-length="11"
      />
      <nut-input
        label-width="70"
        :border="false"
        label="性别"
        placeholder="点击选择性别"
        v-model="sex.text"
        @click="showSelectSexPicker = true"
        readonly
      />
      <nut-input
        label-width="50"
        :border="false"
        label="手机"
        placeholder="请输入手机号"
        v-model="phoneNumber"
        max-length="11"
      />

      <nut-input
        v-model="verifyCode"
        label-width="50"
        :border="false"
        label="验证码"
        placeholder="请输入6位验证码"
        type="number"
        max-length="6"
        clearable
        center
      >
        <template #button>
          <nut-button
            size="small"
            type="primary"
            @click="sendSms"
            :disabled="smsTimer !== null || !dataVerify"
            >{{ smsText }}
          </nut-button>
        </template>
      </nut-input>
      <div class="action-btn">
        <nut-button
          type="warning"
          @click="submitOrder"
          :disabled="verifyCode.length != 6"
          block
          >提交
        </nut-button>
      </div>
    </div>

    <!--    classPicker-->
    <nut-picker
      v-model:visible="showSelectClassPicker"
      :columns="school.class"
      title="选择班级"
      @confirm="confirmClass"
    />
    <nut-picker
      v-model:visible="showSelectProductPicker"
      :columns="school.products"
      title="选择套餐"
      @confirm="confirmProduct"
    />
    <nut-datepicker
      v-model:visible="showSelectDatePicker"
      :max-date="new Date()"
      v-model="currDate"
      :min-date="new Date(new Date().getFullYear() - 20, 1, 1)"
      :is-show-chinese="true"
      :three-dimensional="false"
      @confirm="confirmDate"
    ></nut-datepicker>
    <nut-picker
      v-model:visible="showSelectSexPicker"
      :columns="sexMap"
      title="选择性别"
      @confirm="confirmSex"
    />
  </div>
</template>

<script>
import api from "@/http/api";
import { Toast } from "@nutui/nutui";
//var baseurl = "http://localhost/hsg_cms";
var baseurl = "https://api.haoshengao.com";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      school: {
        name: "不要恶意访问系统",
      },
      classObject: {
        text: null,
      },
      productObject: {
        text: null,
      },
      currDate: new Date(new Date().getFullYear() - 4, 1, 1),
      phoneNumber: null,
      showSelectClassPicker: false,
      showSelectProductPicker: false,
      enableSendSMS: true,
      smsTimer: null,
      smsText: "发送验证码",
      timeCD: 60,
      dataVerify: false,
      verifyCode: "",
      dateTimeStr: null,
      realName: null,
      showSelectDatePicker: false,
      showSelectSexPicker: false,
      sex: {
        text: null,
        value: null,
      },
      sexMap: [
        {
          text: "女",
          value: "女",
        },
        {
          text: "男",
          value: "男",
        },
      ],
    };
  },
  created() {
    api
      .get(baseurl + "/dbase/admin/jiekou/jiekou!getBanjiTaocan.action", {
        params: {
          id: this.$route.query.id,
        },
      })
      .then((res) => {
        if (res.data.status == false) {
          Toast.text(res.data.info);
        }
        this.school = res.data;
      });
  },
  watch: {
    phoneNumber() {
      this.checkData();
    },
    realName() {
      this.checkData();
    },
  },
  methods: {
    confirmSex({ selectedOptions }) {
      this.sex = selectedOptions[0];
      this.checkData();
    },
    submitOrder() {
      api
        .get(baseurl + "/dbase/admin/jiekou/jiekou!saveOrder.action", {
          params: {
            productId: this.productObject.value,
            classId: this.classObject.value,
            phone: this.phoneNumber,
            verifyCode: this.verifyCode,
            ddid: this.school.ddid,
            date: this.dateTimeStr,
            name: this.realName,
            sex: this.sex.value,
          },
        })
        .then(({ data }) => {
          if (data.status) {
            //保存完数据后生成订单号，之后的操作都会跟着订单ID走
            if (this.productObject.price <= 0) {
              location.href =
                window.location.origin +
                "#/success?name=" +
                this.realName +
                "&id=" +
                data.orderId;
            } else {
              var sucurl = window.location.origin + "#/pay/" + data.orderId;
              var redirect_uri = encodeURIComponent(sucurl)
                .replace(/!/g, "%21")
                .replace(/'/g, "%27")
                .replace(/#/g, "%23")
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29")
                .replace(/\*/g, "%2A")
                .replace(/%20/g, "+");
              location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx426fd0f5f9bab656&redirect_uri=" +
                redirect_uri +
                "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
            }
          } else {
            Toast.text(data.info);
          }
        });
    },
    checkData() {
      let ver1 = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phoneNumber);
      let ver2 = this.productObject.text !== null;
      let ver3 = this.classObject.text !== null;
      let ver4 = this.school.name !== "不要恶意访问系统";
      let ver5 = this.realName != "";
      let ver6 = this.sex.text != "";
      let ver7 = this.dateTimeStr != "";
      if (ver1 && ver2 && ver3 && ver4 && ver5 && ver6 && ver7) {
        this.dataVerify = true;
      } else {
        this.dataVerify = false;
      }
    },
    sendSms() {
      if (this.smsTimer == null && this.classObject.value !== null) {
        api
          .get(baseurl + "/dbase/admin/jiekou/jiekou!getYanZhengma.action", {
            params: {
              phone: this.phoneNumber,
            },
          })
          .then(({ data }) => {
            Toast.text(data.status ? "短信发送成功" : "短信发送失败");
            if (data.status) {
              this.smsText = `${this.timeCD}秒后重发`;
              this.timeCD--;
              this.smsTimer = setInterval(() => {
                if (this.timeCD === 0) {
                  clearInterval(this.smsTimer);
                  this.smsTimer = null;
                  this.smsText = "重发验证码";
                  this.timeCD = 60;
                } else {
                  this.smsText = `${this.timeCD}秒后重发`;
                  this.timeCD--;
                }
              }, 1000);
            }
          });
      }
    },
    clickSelectClass() {
      this.showSelectClassPicker = true;
    },
    clickSelectProduct() {
      this.showSelectProductPicker = true;
    },
    confirmClass({ selectedOptions }) {
      this.classObject = selectedOptions[0];
      this.checkData();
    },
    confirmProduct({ selectedOptions }) {
      this.productObject = selectedOptions[0];
      this.checkData();
    },
    clickSelectDate() {
      this.showSelectDatePicker = true;
    },
    confirmDate({ selectedOptions }) {
      this.dateTimeStr = selectedOptions.map((option) => option.text).join("");
      this.checkData();
    },
  },
};
</script>
<style>
.home {
  padding: 20px;
}

.action-btn {
  padding: 30px;
}
</style>
